const filterButtons = document.querySelectorAll('.filter__btn');
const categoryElements = document.querySelectorAll('.article-item')
const loadMoreButton = document.getElementById('load-more');

const dropdownMobile = document.querySelector('.article-filter__dropdown')
const filterButtonsMobile = document.querySelector('.article-filter__dropdown-content');

// display / display none
function hideElements(hideEl) {
    [...hideEl].forEach((el) => {
        if (!el.classList.contains('hide')) {
            el.classList.add('hide')
        }  
    });
}

function showElements(showEl) {
    [...showEl].forEach((el) => {
        if (el.classList.contains('hide')) {
            el.classList.remove('hide')
        }  
    });
}

// display / display none dropdown menu mobile filter
if(dropdownMobile) {
    document.addEventListener('click', (e) => {
        if((e.target).getAttribute('class') == 'article-filter__dropbtn' ) {
            if(filterButtonsMobile.classList.contains('--hide') ) {
                filterButtonsMobile.classList.remove('--hide')
            } else {
                filterButtonsMobile.classList.add('--hide')
            }
        } else {
            filterButtonsMobile.classList.add('--hide')
        }
    });
}

// Select Filter Category
function filterCategory() {
    [...filterButtons].forEach((btn) => {       
        btn.addEventListener('click', () => {                
            const currentFilter = btn.getAttribute('data-filter');
            hideElements(categoryElements);

            if(loadMoreButton.classList.contains('--disable')) {
                loadMoreButton.classList.remove('--disable')
            }

            loadMore(currentFilter)
        });
    });
}
filterCategory();

// Load elements
let filteredCategory = new Array();

function loadMore(currentFilter) {
    const filterTitle = document.querySelector('#article-filter__dropdown-title');
    const initialLimit = 9;
    let currentCount = initialLimit;
    const articleIncrease = 3;
    filteredCategory = [];

    [...filterButtons].forEach((btn) => {    
        if(btn.getAttribute('data-filter') == currentFilter && !btn.classList.contains('--active')) {
            btn.classList.add('--active'); 
            if(btn.getAttribute('data-filter') != 'all') {
                const [prefix, text] = btn.getAttribute('data-filter').split('-')
                filterTitle.innerText = text;
            } else {
                filterTitle.innerHTML = 'Alle';
            }
        } else if(currentFilter == undefined && !btn.classList.contains('--active')) {
            if(btn.getAttribute('data-filter') == 'all') {
                btn.classList.add('--active'); 
                filterTitle.innerText = 'Alle';
            }
        } else if (btn.getAttribute('data-filter') != currentFilter && btn.classList.contains('--active')) {
            btn.classList.remove('--active');
        }
    });

    [...categoryElements].forEach((item) => {
        if (currentFilter ==  'all' || currentFilter == undefined) {
            filteredCategory.push(item);
        } else {
            if (item.getAttribute('data-category') == currentFilter) {
                filteredCategory.push(item);
            } 
        } 
    });

    if(filteredCategory.length - initialLimit <= 0) {
        loadMoreButton.classList.add('--disable');
    }

    let showArticles = Array.from(filteredCategory).slice(0,currentCount);
    let hideArticles = Array.from(filteredCategory).slice(currentCount);
    hideElements(hideArticles);
    showElements(showArticles);

    document.addEventListener("click", (e) => {
        if (e.target.getAttribute('class') == 'article-load-more' ) {
            if((currentCount + articleIncrease ) < filteredCategory.length) {
                currentCount += articleIncrease;
                showArticles = Array.from(filteredCategory).slice(0,currentCount);
    
                showElements(showArticles);
            } else if ((currentCount + articleIncrease ) == filteredCategory.length) {
                currentCount += articleIncrease;
                showArticles = Array.from(filteredCategory).slice(0,currentCount);
    
                showElements(showArticles);
                loadMoreButton.classList.add('--disable')
            }
            else {
                showArticles = Array.from(filteredCategory).slice(currentCount);
    
                showElements(showArticles);
                loadMoreButton.classList.add('--disable')
            }
        }
    });    
};

if(loadMoreButton) {
    loadMore();
}
